import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'

const propTypes = {
  icon: PropTypes.string,
  description: PropTypes.string,
  level: PropTypes.oneOf(Types.CERTIFICATION_BADGE_TYPES),
}

const defaultProps = {
  icon: '',
  description: '',
  level: Types.CERTIFICATION_INCOMPLETE,
}

const CertificationClass = {
  [Types.CERTIFICATION_EXCELLING]: 'cat1',
  [Types.CERTIFICATION_STRONG]: 'cat2',
  [Types.CERTIFICATION_DEVELOPING]: 'cat3',
  [Types.CERTIFICATION_EMERGING]: 'cat4',
  [Types.CERTIFICATION_INCOMPLETE]: 'cat5',
}

function CertificationBadge({ icon, level, description }) {
  return (
    <div className={`certification ${CertificationClass[level]}`}>
      <img src={icon} alt={`${level} Certification`} />
      <p>{description}</p>
    </div>
  )
}

CertificationBadge.propTypes = propTypes
CertificationBadge.defaultProps = defaultProps

export default CertificationBadge
